import React from "react";

import MainContainer from "../../components/MainContainer";
import BirthdaySettings from "../../components/BirthdaySettings";
import { PageHeader } from "../../components/ui";

const BirthdaySettingsPage = () => {
  return (
    <MainContainer maxWidth scroll>
      <PageHeader
        title="Configurações de aniversário"
        subtitle="Parabéns automáticos para a equipe e para os contatos."
      />
      <BirthdaySettings />
    </MainContainer>
  );
};

export default BirthdaySettingsPage;
